import { useMutation } from '@tanstack/react-query';
import { lt, showSuccessAlert } from '@mews/framework';
import { useRepositoryRegistry } from '@mews-commander/data-access';
import { fetchAccountById } from '@mews-commander/legacy-entities/src/actions';
import { setBills } from '@mews-commander/legacy-entities/src/ducks/bills';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { refreshPage } from '../../app/actions/common';

interface MutationParameters {
    billId: string;
    associatedAccountId: string | null;
    closeDialog: () => void;
}

export const useClosedBillAssociationMutation = () => {
    const dispatch = useCommanderThunkDispatch();
    const { bills } = useRepositoryRegistry();
    return useMutation({
        mutationFn: async ({ billId, associatedAccountId }: MutationParameters) =>
            bills
                .updateClosed({
                    billId,
                    associatedAccountId: { value: associatedAccountId },
                })
                .then(async (result) => {
                    showSuccessAlert({
                        title: lt('BillUpdateSuccessMessage'),
                    });
                    if (associatedAccountId) {
                        return dispatch(fetchAccountById({ accountId: associatedAccountId })).then(() => {
                            dispatch(refreshPage());
                            return result;
                        });
                    }
                    dispatch(refreshPage());
                    return Promise.resolve(result);
                }),
        onSuccess: (response, { closeDialog }) => {
            if (response?.bills?.length) {
                dispatch(setBills(response.bills));
            }

            closeDialog();
        },
    });
};
